import { UnsafePageDescription, UnsafePageTitle, UnsafePageWrapper } from '@style/pages/page.style';

import { Form } from '@component/forms/common.style';
import { NewPasswordForm } from '@form/new-password/new-password.form';

import { useNewPassword } from './new-password.hook';
import { FormWrapper } from './new-password.style';

export const NewPasswordPage = () => {
  const { form, isLoading, error, onReset } = useNewPassword();

  return (
    <UnsafePageWrapper>
      <UnsafePageTitle>Create a new password</UnsafePageTitle>
      <UnsafePageDescription>Choose a new password, min 8 characters</UnsafePageDescription>
      <FormWrapper>
        <Form.Provider onFormFinish={onReset}>
          <NewPasswordForm error={error} form={form} isLoading={isLoading} />
        </Form.Provider>
      </FormWrapper>
    </UnsafePageWrapper>
  );
};
